import { render } from "./IndexInformationAvailmentProcess.vue?vue&type=template&id=48c1ac04"
import script from "./IndexInformationAvailmentProcess.vue?vue&type=script&lang=js"
export * from "./IndexInformationAvailmentProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__